import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { SearchInput } from '../components/ui/Input';
import { FileText, Download, Send, MoreHorizontal, CheckCircle, Loader2, Mail, X } from 'lucide-react';
const summaries = [{
  id: 'PDF-001',
  buyerId: 'User-8823',
  project: 'The Lawson',
  status: 'Sent',
  createdAt: '2 hours ago',
  sentAt: '2 hours ago'
}, {
  id: 'PDF-002',
  buyerId: 'User-7732',
  project: 'The Lawson',
  status: 'Pending',
  createdAt: '5 hours ago',
  sentAt: '-'
}, {
  id: 'PDF-003',
  buyerId: 'User-5519',
  project: 'The Lawson',
  status: 'Sent',
  createdAt: '1 day ago',
  sentAt: '1 day ago'
}, {
  id: 'PDF-004',
  buyerId: 'User-6621',
  project: 'The Samson',
  status: 'Sent',
  createdAt: '3 days ago',
  sentAt: '3 days ago'
}];
const availableBuyers = [{
  id: 'User-8823',
  model: 'The Lawson'
}, {
  id: 'User-7732',
  model: 'The Lawson'
}, {
  id: 'User-5519',
  model: 'The Lawson'
}, {
  id: 'User-6621',
  model: 'The Samson'
}];
export function PDFSummariesPage() {
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState('');
  const [selectedSummary, setSelectedSummary] = useState<any>(null);
  const [pdfStatus, setPDFStatus] = useState<'generating' | 'success'>('generating');
  const [sendStatus, setSendStatus] = useState<'sending' | 'success'>('sending');
  // ESC key handler
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (showGenerateModal) {
          handleCloseGenerateModal();
        }
        if (showSendModal) {
          handleCloseSendModal();
        }
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [showGenerateModal, showSendModal]);
  const handleGenerateNewPDF = () => {
    if (!selectedBuyer) return;
    setPDFStatus('generating');
    // Simulate PDF generation
    setTimeout(() => {
      setPDFStatus('success');
    }, 2000);
  };
  const handleSendPDF = (summary: any) => {
    setSelectedSummary(summary);
    setShowSendModal(true);
    setSendStatus('sending');
    // Simulate sending
    setTimeout(() => {
      setSendStatus('success');
    }, 1500);
  };
  const handleDownload = (summary: any) => {
    // Simulate download
    console.log('Downloading PDF:', summary.id);
    alert(`Downloading ${summary.id} - ${summary.buyerId} selections`);
  };
  const handleCloseGenerateModal = () => {
    setShowGenerateModal(false);
    setSelectedBuyer('');
    setPDFStatus('generating');
  };
  const handleCloseSendModal = () => {
    setShowSendModal(false);
    setSelectedSummary(null);
    setSendStatus('sending');
  };
  return <>
      <div className="space-y-6 max-w-7xl mx-auto" data-id="element-1969">
        <div className="flex items-center justify-between" data-id="element-1970">
          <div data-id="element-1971">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-1972">PDF Summaries</h1>
            <p className="text-slate-500" data-id="element-1973">
              Generated buyer selection summaries and exports.
            </p>
          </div>
          <Button leftIcon={<FileText className="h-4 w-4" data-id="element-1975" />} onClick={() => setShowGenerateModal(true)} data-id="element-1974">
            Generate New PDF
          </Button>
        </div>

        <Card noPadding data-id="element-1976">
          <div className="p-4 border-b border-slate-200 flex items-center justify-between bg-slate-50 rounded-t-xl" data-id="element-1977">
            <SearchInput className="max-w-sm bg-white" placeholder="Search by ID or buyer..." data-id="element-1978" />
            <div className="flex gap-2" data-id="element-1979">
              <Button variant="outline" size="sm" data-id="element-1980">
                Filter
              </Button>
              <Button variant="outline" size="sm" data-id="element-1981">
                Export All
              </Button>
            </div>
          </div>

          <div className="overflow-x-auto" data-id="element-1982">
            <table className="w-full text-left text-sm" data-id="element-1983">
              <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-1984">
                <tr data-id="element-1985">
                  <th className="px-6 py-4" data-id="element-1986">PDF ID</th>
                  <th className="px-6 py-4" data-id="element-1987">Buyer ID</th>
                  <th className="px-6 py-4" data-id="element-1988">Project</th>
                  <th className="px-6 py-4" data-id="element-1989">Status</th>
                  <th className="px-6 py-4" data-id="element-1990">Created</th>
                  <th className="px-6 py-4" data-id="element-1991">Sent</th>
                  <th className="px-6 py-4 text-right" data-id="element-1992">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-1993">
                {summaries.map(summary => <tr key={summary.id} className="hover:bg-slate-50 transition-colors" data-id="element-1994">
                    <td className="px-6 py-4 font-medium text-slate-900" data-id="element-1995">
                      {summary.id}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-1996">
                      {summary.buyerId}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-1997">
                      {summary.project}
                    </td>
                    <td className="px-6 py-4" data-id="element-1998">
                      <Badge variant={summary.status === 'Sent' ? 'success' : 'warning'} data-id="element-1999">
                        {summary.status}
                      </Badge>
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2000">
                      {summary.createdAt}
                    </td>
                    <td className="px-6 py-4 text-slate-600" data-id="element-2001">
                      {summary.sentAt}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2002">
                      <div className="flex items-center justify-end gap-2" data-id="element-2003">
                        <Button variant="ghost" size="sm" leftIcon={<Download className="h-3 w-3" data-id="element-2005" />} onClick={() => handleDownload(summary)} data-id="element-2004">
                          Download
                        </Button>
                        {summary.status === 'Pending' && <Button variant="ghost" size="sm" leftIcon={<Send className="h-3 w-3" data-id="element-2007" />} onClick={() => handleSendPDF(summary)} data-id="element-2006">
                            Send
                          </Button>}
                        {summary.status === 'Sent' && <Button variant="ghost" size="sm" onClick={() => handleSendPDF(summary)} data-id="element-2008">
                            Resend
                          </Button>}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* Generate New PDF Modal */}
      {showGenerateModal && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-2009">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-2010">
            {pdfStatus === 'generating' && !selectedBuyer ? <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-2011">
                  <div data-id="element-2012">
                    <h2 className="text-xl font-bold text-slate-900" data-id="element-2013">
                      Generate New PDF
                    </h2>
                    <p className="text-sm text-slate-500 mt-1" data-id="element-2014">
                      Select a buyer to generate their selection summary
                    </p>
                  </div>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-2015">
                    <X className="h-5 w-5" data-id="element-2016" />
                  </button>
                </div>
                <div className="p-6" data-id="element-2017">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-2018">
                    Select Buyer
                  </label>
                  <select value={selectedBuyer} onChange={e => setSelectedBuyer(e.target.value)} className="w-full px-3 py-2 border border-slate-300 rounded-md bg-white focus:ring-primary-500 focus:border-primary-500" data-id="element-2019">
                    <option value="" data-id="element-2020">Choose a buyer...</option>
                    {availableBuyers.map(buyer => <option key={buyer.id} value={buyer.id} data-id="element-2021">
                        {buyer.id} - {buyer.model}
                      </option>)}
                  </select>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-2022">
                  <Button variant="outline" onClick={handleCloseGenerateModal} data-id="element-2023">
                    Cancel
                  </Button>
                  <Button onClick={handleGenerateNewPDF} disabled={!selectedBuyer} data-id="element-2024">
                    Generate PDF
                  </Button>
                </div>
              </> : pdfStatus === 'generating' ? <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-2025">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-2026">
                    Generating PDF Summary
                  </h2>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-2027">
                    <X className="h-5 w-5" data-id="element-2028" />
                  </button>
                </div>
                <div className="p-6 text-center" data-id="element-2029">
                  <div className="mx-auto w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mb-4" data-id="element-2030">
                    <Loader2 className="h-8 w-8 text-primary-600 animate-spin" data-id="element-2031" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6" data-id="element-2032">
                    Creating selection summary for {selectedBuyer}...
                  </p>
                  <div className="space-y-2 text-left" data-id="element-2033">
                    <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-2034">
                      <CheckCircle className="h-4 w-4 text-green-600" data-id="element-2035" />
                      Collecting buyer selections
                    </div>
                    <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-2036">
                      <Loader2 className="h-4 w-4 text-primary-600 animate-spin" data-id="element-2037" />
                      Generating PDF document
                    </div>
                    <div className="flex items-center gap-3 text-sm text-slate-400" data-id="element-2038">
                      <div className="h-4 w-4 rounded-full border-2 border-slate-300" data-id="element-2039" />
                      Preparing email delivery
                    </div>
                  </div>
                </div>
              </> : <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-2040">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-2041">
                    PDF Generated Successfully
                  </h2>
                  <button onClick={handleCloseGenerateModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-2042">
                    <X className="h-5 w-5" data-id="element-2043" />
                  </button>
                </div>
                <div className="p-6" data-id="element-2044">
                  <div className="mx-auto w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-2045">
                    <CheckCircle className="h-8 w-8 text-green-600" data-id="element-2046" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6 text-center" data-id="element-2047">
                    Selection summary for {selectedBuyer} has been created and
                    sent to the buyer via email.
                  </p>
                  <div className="bg-slate-50 rounded-lg p-4 space-y-2 text-sm" data-id="element-2048">
                    <div className="flex justify-between" data-id="element-2049">
                      <span className="text-slate-600" data-id="element-2050">Buyer ID:</span>
                      <span className="font-medium text-slate-900" data-id="element-2051">
                        {selectedBuyer}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-2052">
                      <span className="text-slate-600" data-id="element-2053">PDF ID:</span>
                      <span className="font-medium text-slate-900" data-id="element-2054">
                        PDF-{String(summaries.length + 1).padStart(3, '0')}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-2055">
                      <span className="text-slate-600" data-id="element-2056">Status:</span>
                      <Badge variant="success" data-id="element-2057">Sent</Badge>
                    </div>
                  </div>
                  <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2" data-id="element-2058">
                    <Mail className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-2059" />
                    <p className="text-xs text-blue-800" data-id="element-2060">
                      Email sent directly to buyer without exposing their email
                      address to your team.
                    </p>
                  </div>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-2061">
                  <Button onClick={handleCloseGenerateModal} data-id="element-2062">Done</Button>
                </div>
              </>}
          </div>
        </div>}

      {/* Send/Resend PDF Modal */}
      {showSendModal && selectedSummary && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-50" data-id="element-2063">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" data-id="element-2064">
            {sendStatus === 'sending' ? <>
                <div className="p-6 text-center" data-id="element-2065">
                  <div className="mx-auto w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mb-4" data-id="element-2066">
                    <Loader2 className="h-8 w-8 text-primary-600 animate-spin" data-id="element-2067" />
                  </div>
                  <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2068">
                    Sending PDF
                  </h2>
                  <p className="text-slate-500 text-sm" data-id="element-2069">
                    Sending {selectedSummary.id} to {selectedSummary.buyerId}...
                  </p>
                </div>
              </> : <>
                <div className="p-6 border-b border-slate-200 flex items-center justify-between" data-id="element-2070">
                  <h2 className="text-xl font-bold text-slate-900" data-id="element-2071">
                    Email Sent Successfully
                  </h2>
                  <button onClick={handleCloseSendModal} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-2072">
                    <X className="h-5 w-5" data-id="element-2073" />
                  </button>
                </div>
                <div className="p-6" data-id="element-2074">
                  <div className="mx-auto w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-2075">
                    <CheckCircle className="h-8 w-8 text-green-600" data-id="element-2076" />
                  </div>
                  <p className="text-slate-500 text-sm mb-6 text-center" data-id="element-2077">
                    PDF summary has been sent to {selectedSummary.buyerId} via
                    email.
                  </p>
                  <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-start gap-2" data-id="element-2078">
                    <Mail className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-2079" />
                    <p className="text-xs text-blue-800" data-id="element-2080">
                      Email sent directly to buyer without exposing their email
                      address to your team.
                    </p>
                  </div>
                </div>
                <div className="p-6 border-t border-slate-200 flex justify-end gap-3" data-id="element-2081">
                  <Button onClick={handleCloseSendModal} data-id="element-2082">Done</Button>
                </div>
              </>}
          </div>
        </div>}
    </>;
}